export const NAVIGATION_MODES = {
  ASSISTANT: "assistant",
  ACCOUNT: "account",
  ADMIN: "admin"
};
